import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPoint, AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { clientEnv } from '@retailer-platform/dashboard/env'
import { qualityScorecardsRouter } from './routing/qualityScorecardsRouter'
import { qualityScorecardsAdminRouter } from './routing/qualityScorecardsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { qualityScorecardsAccessControl } from './access-control/qualityScorecardsAccess.configuration'

// QualityScorecards data is only available and accessible in production.
// Only show Quality Scorecards in local and production environments.
const isLocalOrProduction =
  clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'local' ||
  clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'production'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'quality-scorecards',
  totem: { tool: 'quality-scorecards-dashboard-tool' },
  routes,
  translations: { EN_US },
  routers: {
    scoped: [qualityScorecardsRouter],
    admin: [qualityScorecardsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: isLocalOrProduction
    ? [
        {
          attachTo: AdminNavEntryPoint.Analytics,
          attachToV2: AdminNavEntryPointV2.Analytics,
          subNavItems: [
            {
              route: 'quality-scorecards-admin-overview',
              labelId: 'qualityScorecardsDomain.adminOverviewNav',
              accessControl: qualityScorecardsAccessControl,
            },
          ],
        },
      ]
    : [],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
